"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configure;
exports.__n = exports.__ = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _sprintfJs = require("sprintf-js");

function plural(key, pluralKey) {
  return {
    key: key,
    pluralKey: pluralKey,
    message: key
  };
}

function single(key) {
  return {
    key: key,
    message: key
  };
}

var messages = makeMessages([single('Today'), single('Tomorrow'), single('Yesterday'), single('Not found'), single('... type for more elements'), single('Ok'), single('Refresh'), single('Maximum number of values selected'), single('Press Enter to create'), single('Empty'), single('Select All'), single('Dismiss'), single('AM'), single('PM'), single('Choose File'), single('File not selected'), single('Save'), single('of %s'), single('Error while loading map'), single('Coudn\'t find address %s'), single('MAXIMUM'), single('No rows found'), single('less than minute'), single('All'), single('Fast Search'), single('...%d more'), plural('SELECTED %d ROW', 'SELECTED %d ROWS'), plural('%d year', '%d years'), plural('%d month', '%d months'), plural('%d week', '%d weeks'), plural('%d day', '%d days'), plural('%d hour', '%d hours'), plural('%d minute', '%d minutes'), plural('%d second', '%d seconds')]);
var config = {
  gettext: function gettext(key) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return _sprintfJs.sprintf.apply(void 0, [key].concat(args));
  },
  ngettext: function ngettext(key, pluralKey, count) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      args[_key2 - 3] = arguments[_key2];
    }

    return parseInt(count) === 1 ? _sprintfJs.sprintf.apply(void 0, [key].concat(args)) : _sprintfJs.sprintf.apply(void 0, [pluralKey, count].concat(args));
  },
  messages: messages
};

function makeMessages(messages) {
  var result = {};
  messages.forEach(function (msg) {
    return result[msg.key] = msg;
  });
  return result;
}

function dumpKeys(keys) {
  var result = keys.map(function (key) {
    if (messages[key] && messages[key].pluralKey) {
      return "  __n(\"".concat(key, "\", \"").concat(messages[key].pluralKey, "\"),");
    }

    return "  __(\"".concat(key, "\"),");
  });
  return '[\n' + result.join('\n') + '\n]';
}

function configure(data) {
  if (!(data instanceof Object)) {
    throw new Error('Configure data should be object');
  }

  if (data.messages) {
    var _messages = makeMessages(data.messages(single, plural));

    var wrongKeys = Object.keys(_messages).filter(function (key) {
      return !config.messages.hasOwnProperty(key);
    });

    if (wrongKeys.length > 0) {
      throw new Error("Messages is not defined: ".concat(dumpKeys(wrongKeys)));
    }

    var expectedKeys = Object.keys(config.messages).filter(function (key) {
      return !_messages.hasOwnProperty(key);
    });

    if (expectedKeys.length > 0) {
      console.warn("Messages could be defined: ".concat(dumpKeys(expectedKeys)));
    }

    data.messages = (0, _objectSpread2.default)({}, config.messages, _messages);
  }

  config = (0, _objectSpread2.default)({}, config, data);
}

var __ = function __(key) {
  var _config;

  if (!config.messages.hasOwnProperty(key) || config.messages[key].pluralKey) {
    throw new Error("Message \"".concat(key, "\" is not defined"));
  }

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return (_config = config).gettext.apply(_config, [key].concat(args));
};

exports.__ = __;

var __n = function __n(key, pluralKey) {
  var _config2;

  if (!config.messages.hasOwnProperty(key) || !config.messages[key].pluralKey) {
    throw new Error("Plural message \"".concat(key, "\" is not defined"));
  }

  for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    args[_key4 - 2] = arguments[_key4];
  }

  return (_config2 = config).ngettext.apply(_config2, [key, pluralKey].concat(args));
};

exports.__n = __n;